import * as React from 'react';
import * as moment from 'moment';
import BaseList from '../BaseList/BaseList';

class BankingExportList extends BaseList {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.bankingExport.search,
      search: BaseList.search.bankingExport,
      path: 'payments/banking-export',
      name: 'banking exports',
    });
  }

  renderBody(item) {
    return (
      <span key="id">
        <strong>
          {moment(item.start).format('DD/MM/YYYY')} -{' '}
          {moment(item.end).format('DD/MM/YYYY')}
        </strong>
        <br />
        {item.payments.length} payment{item.payments.length > 1 ? 's' : ''}
        <br />
      </span>
    );
  }

  renderFoot() {
    return null;
  }
}

export default BankingExportList;
